var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gantt-widget" },
    [
      _c("div", { staticClass: "widget-header" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "i",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      placement: "top",
                      theme: "light",
                      arrow: true,
                      animation: "scale-extreme",
                      duration: [200, 200],
                      hideOnClick: true,
                    },
                    expression:
                      "{\n                    placement: 'top',\n                    theme: 'light',\n                    arrow: true,\n                    animation: 'scale-extreme',\n                    duration: [200, 200],\n                    hideOnClick: true,\n                }",
                  },
                ],
                staticClass: "material-icons drag-handle",
                attrs: { content: "Sürükleyerek taşıyabilirsiniz" },
              },
              [_vm._v("\n                drag_indicator\n            ")]
            ),
            _vm._v(" "),
            _c("widget-title", {
              attrs: { widget: _vm.widget, table: _vm.table },
              on: { "widget-updated": _vm.handleWidgetUpdated },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "div",
              { staticClass: "view-switcher" },
              [
                _c(
                  "a-button-group",
                  { attrs: { size: "small" } },
                  _vm._l(_vm.viewModes, function (mode) {
                    return _c(
                      "a-button",
                      {
                        key: mode.value,
                        attrs: {
                          type:
                            _vm.currentViewMode === mode.value
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeViewMode(mode.value)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(mode.label) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("widget-actions", {
              attrs: {
                title: _vm.widget.title,
                widget: _vm.widget,
                table: _vm.table,
              },
              on: {
                fullscreen: _vm.handleFullscreen,
                edit: _vm.handleEdit,
                rename: _vm.handleRename,
                duplicate: _vm.handleDuplicate,
                dock: _vm.handleDock,
                export: _vm.handleExport,
                delete: function ($event) {
                  return _vm.$emit("delete", _vm.widget._id)
                },
                "widget-updated": _vm.handleWidgetUpdated,
                "widget-duplicated": _vm.handleWidgetDuplicated,
                "widget-deleted": _vm.handleWidgetDeleted,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "widget-content" }, [
        !_vm.hasValidSettings
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c(
                  "a-empty",
                  { attrs: { description: "Gantt ayarları yapılmamış" } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleEdit },
                      },
                      [_vm._v("Ayarları Düzenle")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm.loading
          ? _c(
              "div",
              { staticClass: "loading-overlay" },
              [_c("loading-wave", { attrs: { text: "Gantt yükleniyor..." } })],
              1
            )
          : _vm.ganttData && _vm.ganttData.error
          ? _c(
              "div",
              { staticClass: "error-state" },
              [
                _c(
                  "a-empty",
                  {
                    attrs: {
                      description:
                        _vm.ganttData.message ||
                        "Gantt verileri yüklenirken hata oluştu",
                    },
                  },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleEdit },
                      },
                      [_vm._v("Ayarları Kontrol Et")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : !_vm.ganttData ||
            !_vm.ganttData.tasks ||
            _vm.ganttData.tasks.length === 0
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: { description: "Gösterilecek görev bulunamadı" },
                }),
              ],
              1
            )
          : _c("div", { staticClass: "gantt-container" }, [
              _c("div", { ref: "ganttElement", staticClass: "gantt-chart" }),
            ]),
      ]),
      _vm._v(" "),
      _vm.showSettingsModal
        ? _c("gantt-settings-modal", {
            attrs: {
              visible: _vm.showSettingsModal,
              widget: _vm.widget,
              fields: _vm.table.fields,
              table: _vm.table,
            },
            on: {
              close: function ($event) {
                _vm.showSettingsModal = false
              },
              save: _vm.handleSettingsSave,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }